
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockWhsGrid extends Serenity.EntityGrid<IcStockWhsRow, any> {
        protected getColumnsKey() { return IcStockWhsColumns.columnsKey; }
        protected getDialogType() { return IcStockWhsDialog; }
        protected getIdProperty() { return IcStockWhsRow.idProperty; }
        protected getInsertPermission() { return IcStockWhsRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockWhsRow.localTextPrefix; }
        protected getService() { return IcStockWhsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}